import { useState } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
const WhatZeemaAndHowToWork = () => {
  const [more, setMore] = useState(false);
  return <>
      {!more ? <Typography sx={{
      typography: 'bodyRegular__Wallfund',
      color: 'text.text2'
    }} paragraph>
          در سکوی تامین مالی جمعی زیما، سرمایه شما مستقیماً به کسب‌وکارها می‌رسد
          و به توسعه آن‌ها کمک می‌کند. اینجا در یک بستر شفاف و مدیریت‌شده،
          به‌جای روش‌های سنتی…
        </Typography> : <Typography sx={{
      typography: 'bodyRegular__Wallfund',
      color: 'text.text2'
    }} paragraph>
          در سکوی تامین مالی جمعی زیما، سرمایه شما مستقیماً به کسب‌وکارها می‌رسد
          و به توسعه آن‌ها کمک می‌کند. اینجا در یک بستر شفاف و مدیریت‌شده،
          به‌جای روش‌های سنتی…
          <ol style={{
        listStylePosition: 'inside'
      }}>
            <li>در طرح‌های واقعی، سرمایه‌گذاری می‌کنید.</li>
            <li>در تمام مدت پیشرفت طرح، از روند آن مطلع می‌شوید.</li>
            <li>
              در سررسیدهای مقرر، سود مشارکت پیش‌بینی‌شده را دریافت می‌کنید.
            </li>
            <li>
              در پایان اجرای طرح، به همراه آخرین سود، اصل سرمایه خود را نیز
              دریافت می‌کنید.
            </li>
          </ol>
        </Typography>}
      {!more ? <Stack alignItems='center' width='100%'>
          <Button onClick={() => setMore(true)} endIcon={<ArrowDropDownRoundedIcon />} variant='text' size='small' fullWidth={false}>
            بیشتر
          </Button>
        </Stack> : null}
    </>;
};
export default WhatZeemaAndHowToWork;